// EventNameLink.tsx
import React, { useContext } from "react";
import PropTypes from "prop-types";
import { OrgDownloadContext } from "../../../OrganizationPhotos/OrgDownloadContext";
import { securedEventPath } from "../../../../utils/pathUtils";
import { Event } from "../../../OrganizationPhotos/types";

interface Props {
  event: Event;
  eventClickable: boolean;
  isEmbed: boolean;
  cartId: number | null;
  secureAccessToken?: string;
}

const EventNameLink: React.FC<Props> = ({
  event,
  eventClickable,
  isEmbed,
  cartId,
  secureAccessToken
}) => {
  const context = useContext(OrgDownloadContext);

  const href = eventClickable
    ? securedEventPath({
        browsePhotosPath: event.browsePhotosPath,
        organizerUserName: (context && context.organizerUserName) || "",
        embedMode: isEmbed,
        cartId: cartId || "",
        secureAccessToken:
          (context && context.secureAccessToken) || secureAccessToken || ""
      })
    : "#";

  return <a href={href}>{event.name}</a>;
};

export default EventNameLink;
